import { Icon, Menu } from 'antd'
import SubMenu from 'antd/lib/menu/SubMenu'
import { hasAccesPermits } from 'core'
import React, { useMemo } from 'react'
import * as ScreenPermissions from 'core/EventActions'
import { Filler } from 'core/screen-util'

/// new england iso
const NeISOMenu = ({
  onSelect,
  menuTheme,
  currentPath,
  envConfig,
  actionPermits,
  userInfo,
  logout,
  apiTargetInfo,
}) => {
  const { authGodMode, isStackTraceAllowed = true } = envConfig
  const errorTraceAdminScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )

  const errorTraceUserScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_USER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )

  const windAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasWindPowerData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA,
          ScreenPermissions.WIND_ADMIN_POWER_DATA,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasWindAdhoc = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADHOC_MATRIX_REPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasAdminPermission = useMemo(
    _ => {
      const adminMenu =
        authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.IT_REGISTRATION,
            ScreenPermissions.CHANGE_PERMISSIONS,
            ScreenPermissions.ACCESS_PERMISSIONS,
          ],
          matchAny: true,
        })
      return adminMenu
    },
    [actionPermits, authGodMode]
  )
  const wind20AdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS_20],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const Wind20AdminMenu = wind20AdminScreenAccess && (
    <SubMenu title="Wind Management 2.0">
      <Menu.Item key="wind2/plants">Wind Plants</Menu.Item>
      <Menu.Item key="wind2/subgroup">Wind Subgroup</Menu.Item>
      <Menu.Item key="wind2/subgroup-formation">
        Wind Subgroup Formation
      </Menu.Item>
      {/* <Menu.Item key="wind2/contribcond">
            Wind Contribute Condition
          </Menu.Item> */}
      <Menu.Item key="wind2/user-access-right">
        Wind User Access Right
      </Menu.Item>
      <SubMenu title="Wind Support Data">
        <Menu.Item key="wind2/region">Wind NERC Region</Menu.Item>
        <Menu.Item key="wind2/entity">Wind Entity</Menu.Item>
        <Menu.Item key="wind2/scada">SCADA Manufacturer</Menu.Item>
        <Menu.Item key="wind2/turb-manf">Turbine Manufacturer</Menu.Item>
        <Menu.Item key="wind2/turb-type">Turbine Type</Menu.Item>
        <Menu.Item key="wind2/storage-manf">Storage Manufacturer</Menu.Item>
        <Menu.Item key="wind2/storage-inv-manf">
          Storage Inverter Manufacturer
        </Menu.Item>
        <Menu.Item key="wind2/storage-group">Storage Group</Menu.Item>
        {/* <Menu.Item key="wind2/contribcond">
              Wind Contribute Condition
            </Menu.Item> */}
        <Menu.Item key="wind2/causecode">Cause Code</Menu.Item>
        <Menu.Item key="wind2/errors">Wind Error Codes Managament</Menu.Item>
        <Menu.Item key="wind2/lockcheck">Wind Lock Management</Menu.Item>
      </SubMenu>
    </SubMenu>
  )

  const hasWindPowerData20 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA_20,
          ScreenPermissions.WIND_ADMIN_POWER_DATA_20,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const wind2FileCreation = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hideWind2TurbinePerformance = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_WIND2_TURBINE_PERFORMANCE],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2FileImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2ImportCSV = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND_IMPORT_CSV_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasWindReort20 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_REPORT_20],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const Wind20Menu = (hasWindPowerData || hasWindPowerData20) && (
    <SubMenu title="Wind">
      {hasWindPowerData20 && (
        <Menu.ItemGroup>
          <Menu.Item key="wind2/wind-power-data-20">Wind Power 2.0</Menu.Item>
          {!hideWind2TurbinePerformance && (
            <Menu.Item key="wind2/wind-turbine-power-data-20">
              Wind Turbine Performance
            </Menu.Item>
          )}

          <Menu.Item key="wind2/wind2-level2-validation">
            Wind 2.0 Level 2 Validation
          </Menu.Item>
          {/* <Menu.SubMenu key="wind-op-2.0" title="Wind Operation 2.0" /> */}
          {wind2FileCreation && (
            <Menu.Item key="wind2/wind2-file-creation">
              Wind NERC File Creation
            </Menu.Item>
          )}
          {wind2FileImport && (
            <Menu.Item key="wind2/wind2-file-import">
              Wind NERC File Import
            </Menu.Item>
          )}
          {wind2ImportCSV && (
            <Menu.Item key="wind2/wind-import-20">Wind File Import</Menu.Item>
          )}
          {hasWindReort20 && (
            <Menu.Item key="wind2/wind-report-20">Wind Report 2.0</Menu.Item>
          )}
        </Menu.ItemGroup>
      )}

      <Menu.ItemGroup>
        <Menu.Divider />
        {hasWindPowerData && (
          <Menu.Item key="wind/wind-power-data">Wind Power 1.0</Menu.Item>
        )}
      </Menu.ItemGroup>
    </SubMenu>
  )

  return (
    <Menu
      mode="horizontal"
      onSelect={onSelect}
      theme={menuTheme}
      selectedKeys={[currentPath]}
      style={{ height: '40px', width: '100%', display: 'flex' }}
    >
      {hasAdminPermission && (
        <SubMenu
          key="admin"
          title={
            <span>
              <Icon
                type="user-add"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Administration</span>
            </span>
          }
          style={{ height: '64px', lineHeight: '64px', width: '140px' }}
        >
          <SubMenu key="secaccessadmin" title="Security Access">
            <Menu.Item exact key="admin/iso-ne-users">
              ISO-NE Users
            </Menu.Item>
            <Menu.Item exact key="admin/iso-ne-users-mapping">
              ISO-NE Users Mapping
            </Menu.Item>
            <Menu.Item exact key="admin/users">
              GADS Users Management
            </Menu.Item>
            <Menu.Item exact key="admin/role">
              GADS Roles Management
            </Menu.Item>
          </SubMenu>
          <SubMenu title="Unit Configuration">
            <Menu.Item exact key="admin/global-unit-reassignment">
              Global Unit Re-Assignment
            </Menu.Item>

            <Menu.Item exact key="admin/unit">
              Units
            </Menu.Item>
            <Menu.Item exact key="admin/unit-group">
              Unit Groups
            </Menu.Item>
            <Menu.Item exact key="admin/utility-operator">
              Utility/Operator
            </Menu.Item>
            <Menu.Item exact key="admin/unit-type">
              Unit Type Management
            </Menu.Item>
          </SubMenu>
          <SubMenu title="Lock Management">
            <Menu.Item exact key="admin/monthlylock">
              Monthly Lock Management
            </Menu.Item>
            <Menu.Item exact key="admin/unitlock">
              Unit Lock Release
            </Menu.Item>
          </SubMenu>
          <SubMenu title="Configuration">
            <Menu.Item exact key="admin/amp-code-mgmt">
              Amplification Code Management
            </Menu.Item>
            <Menu.Item exact key="admin/cause-code-mgmt">
              Cause Code Management
            </Menu.Item>
            {/* <Menu.Item exact key="admin/contrib-cond">
              Contributing Condition
            </Menu.Item> */}
            <Menu.Item exact key="admin/gads-error-mgmt">
              Error Management
            </Menu.Item>

            <Menu.Item exact key="admin/fail-code-mgmt">
              Fail Code Management
            </Menu.Item>
            <Menu.Item exact key="admin/fuel-code-mgmt">
              Fuel Code Management
            </Menu.Item>
            <Menu.Item exact key="admin/system-component-mgmt">
              System/Component Management
            </Menu.Item>
            <Menu.Item exact key="admin/system-configuration">
              System Configuration
            </Menu.Item>
            <Menu.Item exact key="admin/nercclassavgeford">
              NERC Class Avg. EFORD
            </Menu.Item>
            <Menu.Item exact key="admin/unit-block">
              Unit Block Management
            </Menu.Item>
          </SubMenu>
          {windAdminScreenAccess && (
            <SubMenu title="Wind Management ">
              <Menu.Item exact key="wind/wind-inactive">
                Wind Inactive
              </Menu.Item>
              <Menu.Item exact key="wind/wind-subgroup-access">
                Wind Subgroup Access Right
              </Menu.Item>
              <Menu.Item exact key="wind/wind-plant">
                Wind Plant
              </Menu.Item>
              <Menu.Item exact key="wind/wind-subgroup">
                Wind Subgroup
              </Menu.Item>
              <Menu.Item exact key="wind/wind-utility-operator">
                Wind Utility Operator
              </Menu.Item>
              <Menu.Item exact key="wind/wind-error">
                Wind Error Management
              </Menu.Item>
            </SubMenu>
          )}
          {Wind20AdminMenu}
          {errorTraceAdminScreen && (
            <Menu.Item exact key="admin/errortraceadmin">
              Error Stacktrace Log
            </Menu.Item>
          )}
        </SubMenu>
      )}
      <SubMenu
        title={
          <span>
            <Icon
              type="link"
              style={{ fontSize: '20px', fontWeight: 'bold' }}
            />
            <span>Operation Data</span>
          </span>
        }
        style={{ height: '64px', lineHeight: '64px', width: '150px' }}
      >
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.MONTHLY_OPERATION_VIEW],
            matchAny: true,
          })) && (
          <Menu.Item key="monthlyview">Monthly Operation View</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.NERC_FILE_CREATION],
            matchAny: true,
          })) && (
          <Menu.Item key="nerc-file-creation-antd">
            NERC File Creation
          </Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.PJM_FILE_CREATION],
            matchAny: true,
          })) && (
          <Menu.Item key="pjm-file-creation-antd">PJM File Creation</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARDDATA_IMPORT],
            matchAny: true,
          })) && <Menu.Item key="data-import-antd"> Data Import</Menu.Item>}
        {Wind20Menu}
      </SubMenu>
      {(authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.VALIDATION_RUNCHECK,
            ScreenPermissions.VALIDATION_LOG,
            ScreenPermissions.VALIDATION_MONTHLY,
            ScreenPermissions.VALIDATION_EVENT_PENDING,
            ScreenPermissions.VALIDATION_EVENT_PENDING_APPROVAL,
          ],
          matchAny: true,
        })) && (
        <SubMenu
          title={
            <span>
              <Icon
                type="bulb"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Level 2 Validation</span>
            </span>
          }
          style={{ height: '64px', lineHeight: '64px', width: '170px' }}
        >
          <Menu.Item key="level-2-validation-tab">Validation</Menu.Item>
          <Menu.Item key="level-2-validation-status-antd">
            Validation Status
          </Menu.Item>
        </SubMenu>
      )}
      <SubMenu
        title={
          <span>
            <Icon
              type="credit-card"
              style={{ fontSize: '20px', fontWeight: 'bold' }}
            />
            <span>Card Data</span>
          </span>
        }
        style={{ width: '130px', height: '64px', lineHeight: '64px' }}
      >
        {hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.CARD95_ADMIN,
            ScreenPermissions.CARD95_VIEWER,
          ],
          matchAny: true,
        }) && (
          <Menu.Item key="card95-performance-data-antd">
            Card95 - Performance Data
          </Menu.Item>
        )}
        {hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.CARD97_ADMIN,
            ScreenPermissions.CARD97_VIEWER,
          ],
          matchAny: true,
        }) && (
          <Menu.Item key="card97-event-data"> Card97 - Event Data</Menu.Item>
        )}
        {hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.CARD99_ADMIN,
            ScreenPermissions.CARD99_VIEWER,
          ],
          matchAny: true,
        }) && (
          <Menu.Item key="card99-fuel-data-antd">Card99 - Fuel Data</Menu.Item>
        )}
        {hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            // ScreenPermissions.CARD_HISTORY_VIEWER,
            ScreenPermissions.CARD95_HISTORY_VIEWER,
            ScreenPermissions.CARD97_HISTORY_VIEWER,
            ScreenPermissions.CARD99_HISTORY_VIEWER,
          ],
          matchAny: true,
        }) && (
          <Menu.Item key="card-history-data-antd"> Card History Data</Menu.Item>
        )}
      </SubMenu>
      <SubMenu
        title={
          <span>
            <Icon
              type="audit"
              style={{
                height: '64px',
                lineHeight: '64px',
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            />
            <span>Reports</span>
          </span>
        }
        style={{ width: '100px', height: '64px', lineHeight: '64px' }}
      >
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
              ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
            ],
            matchAny: true,
          })) && <Menu.Item key="adhoc-report">Ad Hoc Report</Menu.Item>}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.REPORT_ADHOC_PROCESS],
            matchAny: true,
          })) && (
          <Menu.Item key="adhoc-report-process">Ad Hoc DB Process</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.REPORT_ACCESS],
            matchAny: true,
          })) && [
          <Menu.Item key="reportantd">Reports</Menu.Item>,
          <Menu.Item key="completedreports">Completed Reports</Menu.Item>,
        ]}
        {hasWindAdhoc && (
          <Menu.Item key="windadhoc">Wind Ad Hoc Report</Menu.Item>
        )}
      </SubMenu>
      <SubMenu
        title={
          <span>
            <Icon
              type="tool"
              style={{
                height: '64px',
                lineHeight: '64px',
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            />
            Tools
          </span>
        }
        style={{ width: '120px', height: '64px', lineHeight: '64px' }}
      >
        <Menu.Item exact key="admin/causecodelookup">
          Cause Code Lookup
        </Menu.Item>
        <Menu.Item exact key="admin/userinfochange">
          User Info Change
        </Menu.Item>
        {errorTraceUserScreen && (
          <Menu.Item exact key="errortraceuser">
            Error Stacktrace Log
          </Menu.Item>
        )}
        <Menu.Item exact key="admin/eventduracalculator">
          Event Duration Calculator
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="guide">Guide</Menu.Item>
        {/* <Menu.Item
          key={useHistory().location.pathname.substring(
            1,
            useHistory().location.pathname.length
          )}
          style={{ backgroundColor: '#001529' }}
        >
           <a
            href={apiTargetInfo.baseUrl + '/utils/guide?id=manual'}
            target="_self"
            style={{ backgroundColor: '#001529' }}
          > 
            Guide
           </a> 
        </Menu.Item> */}
      </SubMenu>
      <Filler />
      <SubMenu
        title={
          <Icon
            type="user"
            style={{
              height: '64px',
              lineHeight: '64px',
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          />
        }
        style={{
          width: '50px',
          height: '64px',
          lineHeight: '64px',
          marginRight: '50px',
        }}
      >
        <Menu.Item disabled>
          <div style={{ color: 'white' }}>@{userInfo.userName}</div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="versions">Versions</Menu.Item>
        <Menu.Divider />
        <Menu.Item key="/">
          <a
            href="#"
            // onClick={logout}
            onClick={e => logout(e, apiTargetInfo)}
            style={{ marginRight: '20px', color: '#fff' }}
          >
            Log out
          </a>
        </Menu.Item>
      </SubMenu>
    </Menu>
  )
}

export default NeISOMenu
